import styled from '@emotion/styled';
import React from 'react';
import { Container } from '../../components/container/Container';
import { device } from '../../styles/devices';
import { typography } from '../../styles/typography';

export interface IProps {
  text: React.ReactNode;
  groups: React.ReactNode;
  social: React.ReactNode;
  shortcuts?: React.ReactNode;
}

const Host = styled.footer`
  display: flex;
  flex-flow: row nowrap;

  padding: 65px 0 100px;
  background-color: ${(props) => props.theme.colors.backgroundAlt};
  font-size: 14px;
  position: relative;
  z-index: 1;
`;

const Wrapper = styled.div`
  display: flex;
  flex-flow: column-reverse nowrap;

  @media ${device.desktop} {
    flex-flow: row nowrap;
  }
`;

const TopWrapper = styled(Wrapper)`
  flex-flow: column nowrap;
  margin: 0 0 50px;
`;

const First = styled.div`
  margin-bottom: 2em;
`;

const Last = styled.div`
  ${typography.body}

  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;

  @media ${device.desktop} {
    flex-flow: row wrap;
    margin-left: auto;
  }

  > * {
    margin-bottom: 20px;
    @media ${device.tablet} {
      margin-bottom: 0;
    }
    margin-right: 25px;
    &:last-child {
      margin-right: 25px;
    }

    &:first-child {
      color: ${(props) => props.theme.colors.primary};
    }

    &:nth-child(2) {
      color: ${(props) => props.theme.colors.secondary};
    }

    &:nth-child(3) {
      color: ${(props) => props.theme.shades.ternary5};
    }
  }
`;

const Text = styled.div`
  margin-bottom: 30px;
  p {
    font-size: 14px;
    line-height: ${`calc(27 / ${typography.sizes.bodySize})`};
  }

  strong {
    font-weight: 500;
  }
`;

const Social = styled.div`
  display: flex;
  align-items: center;

  > * {
    margin-right: 8px;
  }
`;

const Groups = styled.div`
  display: flex;
  flex-flow: row wrap;

  margin-bottom: 30px;

  @media ${device.tablet} {
    flex-flow: row nowrap;
    margin-left: 0;
  }
  @media ${device.desktop} {
    margin-bottom: 0;
    margin-left: auto;
  }

  @media ${device.pageLimit} {
    padding-right: 30px;
  }
`;

export const Footer = ({ text, social, groups, shortcuts }: IProps) => {
  return (
    <Host role="contentinfo">
      <Container>
        <TopWrapper>
          <First>
            <Social>{social}</Social>
          </First>
          <Last>{shortcuts}</Last>
        </TopWrapper>
        <Wrapper>
          <First>
            <Text>{text}</Text>
          </First>
          <Groups>{groups}</Groups>
        </Wrapper>
      </Container>
    </Host>
  );
};
